document.addEventListener('DOMContentLoaded', function() {
  function translateVariantLabels() {
    const labels = document.querySelectorAll('.text-subdued');
    labels.forEach(label => {
      if (label.textContent.includes('Color:')) {
        label.textContent = label.textContent.replace('Color:', 'Farve:');
      } else if (label.textContent.includes('Size:')) {
        label.textContent = label.textContent.replace('Size:', 'Størrelse:');
      }
    });
  }

  // Initial translation
  translateVariantLabels();

  // Watch for dynamic content changes
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        translateVariantLabels();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
